import { useState } from 'react';
import { ArrowLeft } from 'lucide-react';

import type { Configuracao } from '@/api/secretario';
import { Button } from '@/components/ui/button';

import { BaseUniversalCard } from './BaseUniversalCard';
import { EnderecoDoEscritorio } from './EnderecoDoEscritorio';
import { HonorariosGeraisCard } from './HonorariosGeraisCard';
import { ModelosPadrao } from './ModelosPadrao';
import { SalvaAoSair } from './SalvaAoSair';

type Secao = 'honorarios' | 'modelos' | 'endereco' | 'base';

/**
 * O padrão do escritório (docs/PLANO_SECRETARIO_ESCRITORIO.md §4.4): honorários e modelos
 * de quem não tem os próprios, o endereço que qualifica os advogados e o que se pede em
 * toda área. Tem a forma do perfil de um advogado — o escritório é mais um "perfil".
 */
export function PadraoDoEscritorio({ config, onVoltar }: { config: Configuracao; onVoltar: () => void }) {
  const [aberta, setAberta] = useState<Secao | null>(null);
  const abrir = (secao: Secao) => (o: boolean) => setAberta(o ? secao : null);
  return (
    <SalvaAoSair configuracaoId={config.id}>
    <div className="space-y-4">
      <Button type="button" variant="ghost" className="-ml-3 min-h-11" onClick={onVoltar}>
        <ArrowLeft className="mr-1.5 h-4 w-4" />
        Advogados
      </Button>
      <div className="space-y-1">
        <h2 className="text-lg font-semibold">Padrão do escritório</h2>
        <p className="text-sm text-muted-foreground">Vale para o advogado que não definiu os próprios.</p>
      </div>
      <HonorariosGeraisCard config={config} open={aberta === 'honorarios'} onOpenChange={abrir('honorarios')} />
      <ModelosPadrao config={config} open={aberta === 'modelos'} onOpenChange={abrir('modelos')} />
      <EnderecoDoEscritorio config={config} open={aberta === 'endereco'} onOpenChange={abrir('endereco')} />
      <BaseUniversalCard
        config={config}
        open={aberta === 'base'}
        onOpenChange={abrir('base')}
        concluida={false}
        onConcluir={() => setAberta(null)}
      />
    </div>
    </SalvaAoSair>
  );
}
